import * as React from "react";
import MuiAvatar from "@mui/material/Avatar";
import { Skeleton } from "@mui/material";

const stringToColor = (string) => {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
};

const avatarProps = (firstName, lastName, error, sx) => {
  if (error || (!firstName && !lastName)) {
    //will fallback to default avatar image
    return {
      sx,
    };
  }
  const firstInitial = (firstName && firstName[0]) ?? "";
  const secondInitial = (lastName && lastName[0]) ?? "";
  const name = `${firstName ?? ""} ${lastName ?? ""}`;
  return {
    sx: {
      ...(sx ?? {}),
      bgcolor: stringToColor(name),
    },
    children: `${firstInitial}${secondInitial}`,
  };
};

export default function Avatar({
  firstName,
  lastName,
  loading,
  error,
  sx,
  size,
}) {
  const sizePx = size === "small" ? 32 : 48;
  const sxWithDimensions = {
    width: sizePx,
    height: sizePx,
    ...(sx ?? {}),
  };
  if (loading) {
    return <Skeleton variant="circular" sx={sxWithDimensions} />;
  }
  return (
    <MuiAvatar {...avatarProps(firstName, lastName, error, sxWithDimensions)} />
  );
}
